<template>
    <div class="joe-gym">
        <div class="joe-gym__container">
            <!-- Banner -->
            <div class="joe-gym__banner">
                <h3 class="joe-gym__body-title">Explore Joe's Gym</h3>
                <img src="@/assets/joe-gym-banner.jpg" alt="Joe's Gym Image" />
            </div>

            <!-- Video Block -->
            <div class="joe-gym__media-block">
                <div class="joe-gym__video">
                    <iframe
                        src="https://www.youtube.com/embed/5mKcvTChl_I"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        title="This is an embedded iframe video"
                    ></iframe>
                </div>
                <div class="joe-gym__body">
                    <h3 class="joe-gym__body-title">Step into Pilates History</h3>
                    <p class="joe-gym__body-desc">
                        A Pilates experience modeled after Joe's original studio. Instructors observe and offer guidance, as you work independently on our authentic Contrology® apparatus.
                    </p>
                    <p class="joe-gym__body-desc">
                        Everyone is welcome. Joe's Gym is open for play whenever it's not used for a workshop. Discover it at <a href="https://www.pilates.com/pilates-events-continuing-education" target="_blank">Pilates On Tour event</a> or a pop-up event near you.
                    </p>
                </div>
            </div>

            <!-- Event Cards -->
            <section class="joe-gym__events">
                <h3 class="joe-gym__event-title">Find Joe's Gym at an Upcoming Event:</h3>
                <div class="loading" v-if="loading">
                    <img src="https://s3.amazonaws.com/s3.pilates.com/img/contrology-loader.gif" alt="Stay tuned"/>
                </div>
                <div v-else-if="error">
                    <p>{{ error }}</p>
                </div>
                <div v-else>
                    <div class="joe-gym__events-list">
                        <event-card
                            v-for="event in displayedEvents"
                            :key="event._id"
                            :event="event"
                            class="event"
                        />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import ApiService from '@/js/ApiService.js';
import EventCard from '@/components/EventCard.vue';

export default {
    name: 'joegym',

    metaInfo: {
        title: "Joe's Gym - Contrology Pilates Events",
        titleTemplate: "%s",
        meta: [
            {
                name: "description",
                content: "Enjoy a Pilates studio experience like that of Joe's original studio."
            },
            {
            property: "og:image",
            content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-default.jpg"
            }
        ]
    },

    components: {
        EventCard
    },

    data() {
        return {
            error: null,
            loading: false,
            events: [],
        }
    },

    created() {
        this.fetchEvents();
    },

    methods: {
        fetchEvents() {
            this.error = "";
            this.loading = true;
            ApiService.getEvents()
            .then(response => {
                this.loading = false;
                this.events = response.data;
                this.displayedEvents = this.joesGymFilter();
            })
            .catch(error => {
                this.loading = false;
                console.log(error);
                this.error = "Events Not Found";
            })
        },

        joesGymFilter() {
            this.filteredEvents = this.events.filter(function(event) {
                return event.joes_gym == true;
            })
            return this.filteredEvents;
        },
    }
};
</script>

<style scoped>
.joe-gym {
    padding: 20px 0 160px;
    margin: 0 -30px;
}

.joe-gym__container {
    width: 100%;
    max-width: 565px;
    margin: auto;
}

.joe-gym__banner {
    width: 100%;
    height: auto;
}
.joe-gym__banner img {
    width: 100%;
    object-fit: cover;
    object-position: center;
}

.joe-gym__media-block {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    margin: 45px 0 55px;
}
.joe-gym__video {
    position: relative;
}
.joe-gym__video::before {
    display: block;
    content: "";
    padding-top: calc((265 / 470) * 100%);
    min-height: 170px;
}
.joe-gym__video iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.joe-gym__body-title,
.joe-gym__event-title {
    text-align: left;
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 15px;
    font-weight: 300;
    font-size: 32px;
    line-height: 115%;
    letter-spacing: 0.065em;
    color: #000000;
}

.joe-gym__body-desc {
    margin: 0;
    font-family: var(--noto);
    font-weight: 300;
    line-height: 140.62%;
    letter-spacing: 0.03em;
}
.joe-gym__body-desc:not(:last-child) {
    margin-bottom: 7px;
}
.loading {
  position: relative;
  top: 5%;
  left: 50%;
  transform: translateX(-16px);
}
.joe-gym__events-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
}

@media only screen and (min-width: 769px) {
    .joe-gym {
        padding-top: 40px;
    }

    .joe-gym__container {
        max-width: 915px;
    }

    .joe-gym__media-block {
        flex-direction: row;
        column-gap: 5%;
        align-items: center;
    }
    .joe-gym__video {
        flex: 0 0 55%;
        max-width: 470px;
    }
    .joe-gym__body {
        padding-right: 1%;
    }
}
</style>
